// ----------------------------------------------------------------------------
// Component: Hero Countdown
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_hero-countdown.scss';
import $ from 'jquery';

function countDown() {
    //Makes end date field readable for all browsers.
    let endDate = new Date($("#hero-countdown-endtime").val().replace(/\-/g,'\/').replace(/[T|Z]/g,' '));
    let nowDate = new Date();
    let dateDiff = (endDate - nowDate ) / 1000;
    
    if (dateDiff > 0) {
        let day = Math.floor(dateDiff / 3600 / 24);
        let hour = Math.floor(dateDiff / 3600) % 24;
        let min = Math.floor(dateDiff / 60) % 60;
        let sec = Math.floor(dateDiff % 60);
            
        $(".hero-countdown__timer__days .time-block--number").text(day.toString().padStart(2, '0'));
        $(".hero-countdown__timer__hours .time-block--number").text(hour.toString().padStart(2, '0'));
        $(".hero-countdown__timer__minutes .time-block--number").text(min.toString().padStart(2, '0'));
        $(".hero-countdown__timer__seconds .time-block--number").text(sec.toString().padStart(2, '0'));
    }
}

$(function() {
    
    let $heroCountdown = $('.page-section--hero-countdown');
    
    if ($heroCountdown.length) {
        let startCountdown = setInterval(() => {
            countDown();
        }, 1000);
    }
});

